/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_TitleInputs */

const en_cp_lead_title = /** @type {(inputs: Cp_Lead_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead Bystep at your university`)
};

const id_cp_lead_title = /** @type {(inputs: Cp_Lead_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadi penggerak Bystep di kampusmu`)
};

/**
* | output |
* | --- |
* | "Lead Bystep at your university" |
*
* @param {Cp_Lead_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_title = /** @type {((inputs?: Cp_Lead_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_title(inputs)
	return en_cp_lead_title(inputs)
});